import {AuthService} from '../services/auth.service';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {HeaderService} from '../services/header.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  username: string;
  password: string;
  loginSub: Subscription;
  enrollEnabled: boolean;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private headerService: HeaderService,
    private router: Router
  ) {}

  ngOnInit() {
    this.username = '';
    this.password = '';
    this.enrollEnabled = true;
  }

  login(registrationId: string) {
    if (registrationId === 'cardholder') {
      window.location.href = `${environment.rootUrl}/oauth2/authorization/cardholder`;
    } else if (registrationId === 'agent') {
      window.location.href = `${environment.rootUrl}/oauth2/authorization/agent`;
    }
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  authenticate() {
    // Attempting login so clear session variables
    this.authService.clearSessionVariables();
    const loginSuccess = this.authService.authenticate();

    this.loginSub = loginSuccess.subscribe((result: any) => {
      if (this.authService.redirectUrl) {
        this.router.navigate([this.authService.redirectUrl.substring(1)]);
      } else {
        this.router.navigate(['users/messages']);
      }
    });
  }

  ngOnDestroy() {
    if (this.loginSub) {
      this.loginSub.unsubscribe();
    }
  }

}
